export default {
    generalSettings: '通用设置',
    changeDisplayLanguage: '界面显示语言',
    changeDisplayLanguageInfo: '为平台设置默认的显示语言',
    nav: {
        audits: '项目审计',
        vulnerabilities: '漏洞管理',
        data: '数据管理',
    },
    btn: {
        cancel: '取消',
        confirm: '确认',
        create: '创建',
        generateAnyway: '仍然生成',
        topButtonSection: {
            submitReview: '提交审核',
            cancelReview: '取消审核',
            approve: '批准',
            removeApproval: '移除批准',
        },
        backupFinding: "提议在漏洞库中创建/更新",
        delete: '删除',
        save: '保存',
        saved: '已保存',
        update: '更新',
        deleteAll: '全部删除',
        close: 'Close',
        enable: '启用',
        valid: '有效的',
        new: '新的',
        updates: '有更新的',
        updatesAvailable: '有可用更新',
        dismissAllUpdates: '忽略所有{language}提案',
        dismissProposal: '忽略所选提案',
        dismissEveryUpdate: '忽略所有提案',
        accountsEnabled: '账号启用',
        accountsDisabled: '账号禁用',
        accountEnabled: '账号启用',
        accountDisabled: '账号禁用',
        disable: '禁用',
        qa: 'QA',
        comments: '评论',
        discard: '放弃',
    },
    tooltip: {
        vulnerabilityUpdates: '查看此漏洞的更新提案',
        usersConnected: '正在做审计的用户',
        editAudit: '编辑审计',
        downloadReport: '下载报告',
        downloadReportWithUnsavedDrafts: '存在本地恢复更改，保存前不会包含在报告中',
        auditDraftUnsavedChanges: '存在本地恢复更改',
        deleteAudit: '删除审计',
        topButtonSection: {
            submitReview: '标记项目已准备好审核',
            cancelReview: '更改项目时需先取消审核',
            approve: '对该项目审核通过',
            removeApproval: '对该项目移除审核通过',
        },
        sortOptions: '排序选项',
        addToFindings: '添加到问题发现',
        edit: '编辑',
        view: '查看',
        findAudits: '查找审计项目',
        delete: '删除',
        download: '下载',
        auditQa: '显示 QA 面板',
        vulnerabilityQa: '显示 QA 面板',
    },
    msg: {
        auditReviewUpdateOk: '项目审核状态更新成功',
        auditApprovalUpdateOk: '项目批准状态更新成功',
        auditUpdateOk: '项目更新成功',
        findingCreateOk: '问题创建成功',
        findingUpdateOk: '问题更新成功',
        findingDeleteOk: '问题删除成功',
        doYouWantToLeave: '你确定要离开吗？',
        thereAreUnsavedChanges: '有未保存的更改！',
        auditDraftDownloadWarningTitle: '存在本地恢复更改',
        auditDraftDownloadWarningMessage: '此审计存在尚未保存到服务器的本地恢复更改。除非先保存这些更改，否则它们不会包含在生成的报告中。',
        fieldRequired: '请填写所有必填字段',
        deleteFindingConfirm: '确认删除当前问题？',
        deleteFindingNotice: '此操作无法被取消',
        selectHost: '选择主机IP',
        importHostsFirst: '注意：请务必先导入扫描结果，下拉选中主机后IP再点击加号',
        auditTypeNotSet: '审计类型未设置',
        sectionUpdateOk: '段落更新成功',
        lastnameRequired: '“姓”未填写',
        firstnameRequired: '“名”未填写',
        emailRequired: '邮箱未填写',
        clientCreatedOk: '客户创建成功',
        clientUpdatedOk: '客户更新成功',
        clientDeletedOk: '客户删除成功',
        deleteNotice: '将被永久删除',
        confirmSuppression: '请您确认',
        usernameRequired: '用户名未填写',
        passwordRequired: '密码未填写',
        currentPasswordRequired: '当前密码未填写',
        confirmPasswordDifferents: '新密码与确认密码不相同',
        collaboratorCreatedOk: '审计员创建成功',
        collaboratorUpdatedOk: '审计员更新成功',
                roleCreatedOk: 'Role created successfully',
        roleUpdatedOk: 'Role updated successfully',
        roleDeletedOk: 'Role deleted successfully',
        roleDisplayNameRequired: 'Role display name required',
        roleNameRequired: 'Role name required',
        usersUpdatedOk: 'Users updated successfully',
        nameRequired: "名称未填写",
        fileRequired: '文件未上传',
        companyCreatedOk: '公司创建成功',
        companyUpdatedOk: '公司更新成功',
        companyDeletedOk: '公司删除成功',
        templateNotFound: '未找到模板',
        templateCreatedOk: '模板创建成功',
        templateUpdatedOk: '目标更新成功',
        allVulnerabilitesDeleteNotice: '所有漏洞将会被永久删除？',
        allVulnerabilitesDeleteOk: '所有漏洞删除成功',
        profileUpdateOk: '个人信息更新成功',
        settingsUpdatedOk: '系统设置更新成功',
        revertingSettings: '还原系统配置！',
        revertingSettingsConfirm: '您确认要还原系统配置吗？您将失去所有当前配置。',
        importingSettings: '导入系统配置！',
        importingSettingsConfirm: '您确认要导入系统配置吗？您将失去所有当前配置。',
        settingsImportedOk: '系统配置导入成功',
        vulnerabilityCreatedOk: '漏洞创建成功',
        vulnerabilityUpdatedOk: '漏洞更新成功',
        vulnerabilityDeletedOk: '漏洞删除成功',
        vulnerabilityWillBeDeleted: '漏洞将会被永久删除',
        updatesDismissedOk: '更新提案已忽略',
        confirmDismissUpdates: '确认忽略',
        updatesWillBeDismissed: '所有{language}更新提案将被永久删除',
        updateWillBeDismissed: '{creator} 的提案将被永久删除',
        everyUpdateWillBeDismissed: '该漏洞在所有语言下的全部更新提案都将被永久删除',
        confirmCategoryChange: '确认类别更改',
        categoryChangingNotice: '更改类别将会影响自定义字段显示',
        vulnerabilityMergeOk: '漏洞合并成功',
        tryingToContactBackend: '<p>尝试连接后端服务</p>',
        wrongContactingBackend: '连接后端服务失败',
    },
    err: {
        notDefinedLanguage: '没有定义这种语言',
        invalidYamlFormat: '检测到无效的 YAML 格式',
        parsingError1: '解析错误： {0}',
        parsingError2: '解析错误： line {0}， column: {1}',
        invalidJsonFormat: '检测到无效的 JSON 格式',
        jsonMustBeAnObject: 'JSON 必须为 object。',
        importingSettingsError: '导入系统配置错误',
        errorWhileParsingJsonContent: '解析JSON内容出错：{0}',
        titleRequired: '标题未填写',
        expiredToken: 'token过期',
        invalidToken: '无效token',
        invalidCredentials: '无效身份',
    },
    cvss: {
        title: 'CVSSv3 基础评分',
        impactSubscore: '影响子分数',
        exploitabilitySubscore: '可利用性子分数',
        infoWhenNoScore: '选择所有基本指标的值以生成分数',
        attackVector: '攻击向量',
        attackComplexity: '攻击复杂度',
        privilegesRequired: '权限需求',
        userInteraction: '用户交互',
        scope: '作用域',
        confidentialityImpact: '保密性影响',
        integrityImpact: '完整性影响',
        availabilityImpact: '可用性影响',
        network: '互联网',
        adjacentNetwork: '临近网络',
        local: '局域网',
        physical: '物理',
        low: '低',
        high: '高',
        required: '需要',
        none: '无',
        unchanged: '不变',
        changed: '改变',
        temporalEnvironmentalTitle: '时间和环境分数',
        temporalTitle: '时间分数',
        environmentalTitle: '环境分数',
        environmentalModifiedImpact: '修改后的影响子分数',
        environmentalModifiedExploitability: '修改后的可利用性子分数',
        exploitCodeMaturity: '漏洞利用代码成熟度',
        remediationLevel: '恢复级别',
        reportConfidence: '报告可信度',
        confidentialityRequirement: '保密性要求',
        integrityRequirement: '完整性要求',
        availabilityRequirement: '可用性要求',
        modifiedAttackVector: '修改后的攻击向量',
        modifiedAttackComplexity: '修改后的攻击复杂度',
        modifiedPrivilegesRequired: '修改后的权限需求',
        modifiedUserInteraction: '修改后的用户交互度',
        modifiedScope: '修改后的作用域',
        modifiedConfidentialityImpact: '修改后的保密性影响',
        modifiedIntegrityImpact: '修改后的完整性影响',
        modifiedAvailabilityImpact: '修改后的可用性影响',
        notDefined: '未定义',
        unproven: '未证实',
        poc: 'POC',
        functional: '功能性',
        officialFix: '官方修复',
        temporaryFix: '临时修复',
        workaround: '解决方案',
        unavailable: '不可用',
        unknown: '未知',
        reasonable: '合理',
        confirmed: '已确认',
        medium: '中等',
        tooltip: {
            baseMetricGroup_Legend: "“基本指标”组代表漏洞的内在特征，这些特征在不同时间和用户环境中是恒定的。 确定易受攻击的组件并对攻击向量、攻击复杂性、所需权限和与此相关的用户交互进行评分。",
            AV_Heading: "该指标反映了可能利用漏洞的环境。 为了利用易受攻击的组件，攻击者距离越远（逻辑上和物理上），基础分数就越增加越多。",
            AV_N_Label: "易受攻击的组件绑定到网络堆栈，并且可能的攻击者集合超出了列出的其他选项，甚至包括整个 Internet。 这种漏洞通常被称为“可远程利用”，并且可以被认为是一种可在协议级别利用一个或多个网络跃点（例如，跨一个或多个路由器）的攻击。",
            AV_A_Label: "易受攻击的组件绑定到网络堆栈，但攻击仅限于协议级别的相邻网络逻辑拓扑。 这可能意味着必须从相同的共享物理（例如，蓝牙或 无线）或逻辑（例如，本地 IP 子网）网络，或从安全或其他受限的管理域（例如，MPLS、安全 VPN 到一个管理网络区域）。",
            AV_L_Label: "易受攻击的组件未绑定到网络堆栈，攻击者的路径是通过读/写/执行功能。 要么：攻击者通过本地（例如，键盘、控制台）或远程（例如，SSH）访问目标系统来利用漏洞； 或者攻击者依靠其他人的用户交互来执行利用漏洞所需的操作（例如，诱骗合法用户打开恶意文档）。",
            AV_P_Label: "攻击需要攻击者物理接触或操纵易受攻击的组件。 物理交互可能是短暂的或持久的。",
            AC_Heading: "该指标描述了为了利用漏洞而必须存在的超出攻击者控制范围的条件。 这种情况可能需要收集有关目标或计算异常的更多信息。 该指标的评估不包括为利用漏洞而进行的任何用户交互要求。 如果攻击成功需要特定配置，则应假设易受攻击的组件在该配置中，对基本指标进行评分。",
            AC_L_Label: "不存在专门的准入条件或情有可原的情况。 攻击者可以期望针对易受攻击的组件取得可重复的成功。",
            AC_H_Label: "成功的攻击取决于攻击者无法控制的条件。 也就是说，成功的攻击不能随意完成，而是需要攻击者投入一些可衡量的努力来准备或执行针对易受攻击的组件，然后才能预期成功的攻击。 例如，成功的攻击可能需要攻击者： 收集有关易受攻击目标/组件所在环境的知识； 准备目标环境以提高漏洞利用的可靠性； 或者将自己注入到目标和受害者请求的资源之间的逻辑网络路径中，以读取和/或修改网络通信（例如，中间人攻击）。",
            PR_Heading: "该指标描述了攻击者在成功利用漏洞之前必须拥有的权限级别。",
            PR_N_Label: "攻击者在攻击之前是未经授权的，因此不需要对设置或文件进行任何访问即可进行攻击。",
            PR_L_Label: "攻击者被授权（即要求）提供基本用户功能的权限，这些权限通常只影响用户拥有的设置和文件。 或者，具有低权限的攻击者可能只对非敏感资源造成影响。",
            PR_H_Label: "攻击者被授权（即要求）特权，这些特权提供对可能影响组件范围设置和文件的易受攻击组件的重要（例如，管理）控制。",
            UI_Heading: "该指标衡量用户（而非攻击者）参与成功入侵易受攻击组件的要求。 该指标确定漏洞是否可以完全按照攻击者的意愿被利用，或者单独的用户（或用户启动的进程）是否必须以某种方式参与。",
            UI_N_Label: "易受攻击的系统可以在没有任何用户交互的情况下被利用。",
            UI_R_Label: "成功利用此漏洞需要用户采取一些措施才能利用此漏洞。",
            S_Heading: "成功的攻击是否会影响易受攻击组件以外的组件？ 如果是这样，则基础分数会增加，并且机密性、完整性和身份验证指标应相对于受影响的组件进行评分。",
            S_U_Label: "被利用的漏洞只能影响由同一安全机构管理的资源。 在这种情况下，易受攻击的组件和受影响的组件要么相同，要么都由相同的安全机构管理。",
            S_C_Label: "被利用的漏洞可能会影响超出易受攻击组件的安全权限管理的安全范围的资源。 在这种情况下，易受攻击的组件和受影响的组件是不同的，由不同的安全机构管理。",
            C_Heading: "该指标衡量由于成功利用漏洞而对软件组件管理的信息资源的机密性的影响。 机密性是指将信息访问和披露仅限于授权用户，以及防止未经授权的用户访问或披露。",
            C_N_Label: "受影响组件内的机密性不会丢失。",
            C_L_Label: "有一些保密性的损失。 获得了对某些受限信息的访问权，但攻击者无法控制获得的信息，或者损失的数量或种类受到限制。 信息披露不会对受影响的组成部分造成直接的、严重的损失。",
            C_H_Label: "机密性完全丧失，导致受影响组件中的所有资源都泄露给攻击者。 或者，仅获得了对一些受限信息的访问权，但所披露的信息会产生直接、严重的影响。",
            I_Heading: "该指标衡量成功利用的漏洞对完整性的影响。 完整性是指信息的可信度和真实性。",
            I_N_Label: "受影响的组件内没有完整性损失。",
            I_L_Label: "可以修改数据，但攻击者无法控制修改的结果，或者修改的数量有限。 数据修改不会对受影响的组件产生直接、严重的影响。",
            I_H_Label: "完全丧失完整性，或完全丧失保护。 例如，攻击者能够修改受受影响组件保护的任何/所有文件。 或者，只能修改部分文件，但恶意修改会对受影响的组件造成直接、严重的后果。",
            A_Heading: "该指标衡量成功利用漏洞对受影响组件可用性的影响。 它指的是受影响的组件本身失去可用性，例如网络服务（例如，Web、数据库、电子邮件）。 由于可用性是指信息资源的可访问性，因此消耗网络带宽、处理器周期或磁盘空间的攻击都会影响受影响组件的可用性。",
            A_N_Label: "受影响组件内的可用性没有影响。",
            A_L_Label: "性能降低或资源可用性中断。 即使可以重复利用该漏洞，攻击者也没有能力完全拒绝为合法用户提供服务。 受影响组件中的资源要么始终部分可用，要么仅在某些时间完全可用，但总体而言，受影响组件没有直接、严重的后果。",
            A_H_Label: "可用性完全丧失，导致攻击者能够完全拒绝访问受影响组件中的资源； 这种损失要么是持续的（攻击者继续进行攻击），要么是持久的（即使在攻击完成后情况仍然存在）。 或者，攻击者有能力拒绝某些可用性，但可用性的丧失会给受影响的组件带来直接、严重的后果（例如，攻击者不能中断现有连接，但可以阻止新连接；攻击者可以重复利用漏洞 即，在每次成功攻击的情况下，只会泄漏少量内存，但在反复利用后会导致服务完全不可用）。",
            temporalMetricGroup_Legend: "时间指标衡量漏洞利用技术或代码可用性的当前状态、是否存在任何补丁或变通办法，或者人们对漏洞描述的信心。",
            E_Heading: "该指标衡量漏洞被攻击的可能性，通常基于漏洞利用技术的当前状态、漏洞利用代码可用性或主动的“野外”利用。",
            E_X_Label: "分配此值表示没有足够的信息来选择其他值之一，并且对整体时间分数没有影响，即它对得分的影响与分配高相同。",
            E_U_Label: "没有可用的漏洞利用代码，或者漏洞利用是理论上的。",
            E_P_Label: "可以使用概念验证漏洞利用代码，或者攻击演示对于大多数系统来说是不切实际的。 代码或技术并非在所有情况下都有效，可能需要熟练的攻击者进行大量修改。",
            E_F_Label: "功能漏洞利用代码可用。 该代码适用于存在漏洞的大多数情况。",
            E_H_Label: "存在功能性自治代码，或者不需要利用（手动触发），并且可以广泛获得详细信息。 漏洞利用代码在任何情况下都有效，或者通过自主代理（例如蠕虫或病毒）主动传递。 联网系统可能会遇到扫描或利用尝试。 漏洞利用开发已经达到了可靠、广泛可用、易于使用的自动化工具的水平。",
            RL_Heading: "漏洞的修复级别是确定优先级的重要因素。 典型的漏洞在最初发布时未修补。 在发布正式补丁或升级之前，变通办法或修补程序可能会提供临时补救措施。 这些相应阶段中的每一个都将时间分数向下调整，反映了随着补救措施的最终紧迫性的降低。",
            RL_X_Label: "分配此值表示没有足够的信息来选择其他值之一，并且对整体 “时间分数” 没有影响，即它对评分的影响与分配 “不可用” 相同。",
            RL_O_Label: "提供完整的供应商解决方案。 供应商已经发布了官方补丁，或者可以进行升级。",
            RL_T_Label: "有一个官方但临时的修复程序可用。 这包括供应商发布临时修补程序、工具或解决方法的情况。",
            RL_W_Label: "有一个非官方的、非供应商的解决方案可用。 在某些情况下，受影响技术的用户将创建自己的补丁或提供解决或以其他方式缓解漏洞的步骤。",
            RL_U_Label: "要么没有可用的解决方案，要么无法应用。",
            RC_Heading: "该指标衡量对漏洞存在的信心程度和已知技术细节的可信度。 有时只公开漏洞的存在，而没有具体的细节。 例如，影响可能被认为是不可取的，但根本原因可能未知。 该漏洞稍后可能会被研究证实，该研究表明漏洞可能存在于何处，尽管研究可能不确定。 最后，漏洞可以通过受影响技术的作者或供应商的确认来确认。 当漏洞被确定存在时，漏洞的紧迫性会更高。 该指标还表明潜在攻击者可用的技术知识水平。",
            RC_X_Label: "分配此值表示没有足够的信息来选择其他值之一，并且对整体 “时间分数” 没有影响，即它对评分的影响与分配 “已确认” 相同。",
            RC_U_Label: "有影响报告表明存在漏洞。 报告表明漏洞的原因未知，或者报告可能对漏洞的原因或影响有所不同。 报告者不确定漏洞的真实性质，并且对于报告的有效性或是否可以应用静态基础分数（考虑到所描述的差异）几乎没有信心。 一个例子是一个错误报告，它指出发生了间歇性但不可重现的崩溃，内存损坏的证据表明可能会导致拒绝服务或更严重的影响。",
            RC_R_Label: "重要细节已公布，但研究人员要么对根本原因没有完全信心，要么无法访问源代码来完全确认可能导致结果的所有交互。 但是，存在合理的信心，即该错误是可重现的，并且至少可以验证一个影响（概念证明漏洞利用可能提供这一点）。 一个例子是对漏洞研究的详细记录，并附有解释（可能被混淆或“留给读者作为练习”），以保证如何重现结果。",
            RC_C_Label: "存在详细的报告，或者功能复制是可能的（功能漏洞可以提供这一点）。 源代码可用于独立验证研究的断言，或受影响代码的作者或供应商已确认存在漏洞。",
            environmentalMetricGroup_Legend: "这些指标使分析师能够根据受影响的 IT 资产对用户组织的重要性自定义 CVSS 分数，衡量标准是补充/替代安全控制、机密性、完整性和可用性。 度量是基本度量的修改等效项，并根据组织基础架构中的组件位置分配度量值。",
            CR_Heading: "这些指标使分析师能够根据受影响 IT 资产的机密性对用户组织的重要性（相对于其他影响）自定义 CVSS 分数。 该指标通过重新加权修改后的机密性影响指标与其他修改后的影响来修改环境分数。",
            CR_X_Label: "指定此值表示没有足够的信息来选择其他值之一，并且对整体环境评分没有影响，即它对评分的影响与指定中等相同。",
            CR_L_Label: "失去机密性可能只会对组织或与组织相关的个人（例如，员工、客户）产生有限的不利影响。",
            CR_M_Label: "将此值分配给指标不会影响分数。",
            CR_H_Label: "失去机密性可能会对组织或与组织相关的个人（例如员工、客户）产生灾难性的不利影响。",
            IR_Heading: "这些指标使分析师能够根据受影响 IT 资产的完整性相对于其他影响对用户组织的重要性来自定义 CVSS 分数。 该指标通过重新加权修改后的完整性影响指标与其他修改后的影响来修改环境分数。",
            IR_X_Label: "指定此值表示没有足够的信息来选择其他值之一，并且对整体环境评分没有影响，即它对评分的影响与指定中等相同。",
            IR_L_Label: "丧失诚信可能只会对组织或与组织相关的个人（例如员工、客户）产生有限的不利影响。",
            IR_M_Label: "将此值分配给指标不会影响分数。",
            IR_H_Label: "丧失诚信可能会对组织或与组织相关的个人（例如员工、客户）产生灾难性的不利影响。",
            AR_Heading: "这些指标使分析师能够根据受影响 IT 资产的可用性相对于其他影响对用户组织的重要性来自定义 CVSS 分数。 该指标通过重新加权修改后的可用性影响指标与其他修改后的影响来修改环境分数。",
            AR_X_Label: "指定此值表示没有足够的信息来选择其他值之一，并且对整体环境评分没有影响，即它对评分的影响与指定中等相同。",
            AR_L_Label: "可用性损失可能对组织或与组织相关的个人（例如，员工、客户）仅产生有限的不利影响。",
            AR_M_Label: "将此值分配给指标不会影响分数。",
            AR_H_Label: "可用性损失可能会对组织或与组织相关的个人（例如，员工、客户）产生灾难性的不利影响。",
            MAV_Heading: "该指标反映了可能利用漏洞的环境。 环境分数越高，攻击者可以越远程（逻辑上和物理上）以利用易受攻击的组件。",
            MAV_X_Label: "使用分配给相应基本指标的值。",
            MAV_N_Label: "易受攻击的组件绑定到网络堆栈，并且可能的攻击者集合超出了列出的其他选项，甚至包括整个 Internet。 这种漏洞通常被称为“可远程利用”，并且可以被认为是在一个或多个网络跳远的协议级别上可利用的攻击。",
            MAV_A_Label: "易受攻击的组件绑定到网络堆栈，但攻击仅限于协议级别的逻辑相邻拓扑。 这可能意味着必须从相同的共享物理（例如，蓝牙或 IEEE 802.11）或逻辑（例如，本地 IP 子网）网络，或从安全或其他受限的管理域（例如，MPLS、安全 VPN）内发起攻击 .",
            MAV_L_Label: "易受攻击的组件未绑定到网络堆栈，攻击者的路径是通过读/写/执行功能。 要么：攻击者通过本地（例如，键盘、控制台）或远程（例如，SSH）访问目标系统来利用漏洞； 或者攻击者依靠其他人的用户交互来执行利用漏洞所需的操作（例如，诱骗合法用户打开恶意文档）。",
            MAV_P_Label: "攻击需要攻击者物理接触或操纵易受攻击的组件。 物理交互可能是短暂的或持久的。",
            MAC_Heading: "该指标描述了为了利用漏洞而必须存在的超出攻击者控制范围的条件。 这种情况可能需要收集有关目标或计算异常的更多信息。 该指标的评估不包括为利用漏洞而进行的任何用户交互要求。 如果攻击成功需要特定配置，则应假设易受攻击的组件在该配置中，对基本指标进行评分。",
            MAC_X_Label: "使用分配给相应基本指标的值。",
            MAC_L_Label: "不存在专门的准入条件或情有可原的情况。 攻击者可以期望针对易受攻击的组件取得可重复的成功。",
            MAC_H_Label: "成功的攻击取决于攻击者无法控制的条件。 也就是说，成功的攻击不能随意完成，而是需要攻击者投入一些可衡量的努力来准备或执行针对易受攻击的组件，然后才能预期成功的攻击。 例如，成功的攻击可能需要攻击者： 收集有关易受攻击目标/组件所在环境的知识； 准备目标环境以提高漏洞利用的可靠性； 或者将自己注入到目标和受害者请求的资源之间的逻辑网络路径中，以读取和/或修改网络通信（例如，中间人攻击）。",
            MPR_Heading: "该指标描述了攻击者在成功利用漏洞之前必须拥有的权限级别。",
            MPR_X_Label: "使用分配给相应基本指标的值。",
            MPR_N_Label: "攻击者在攻击之前是未经授权的，因此不需要对设置或文件进行任何访问即可进行攻击。",
            MPR_L_Label: "攻击者被授权（即要求）提供基本用户功能的权限，这些权限通常只影响用户拥有的设置和文件。 或者，具有低权限的攻击者可能只对非敏感资源造成影响。",
            MPR_H_Label: "攻击者被授权（即要求）特权，这些特权提供对可能影响组件范围设置和文件的易受攻击组件的重要（例如，管理）控制。",
            MUI_Heading: "该指标涵盖用户（而非攻击者）参与成功入侵易受攻击组件的要求。 该指标确定漏洞是否可以完全按照攻击者的意愿被利用，或者单独的用户（或用户启动的进程）是否必须以某种方式参与。",
            MUI_X_Label: "使用分配给相应基本指标的值。",
            MUI_N_Label: "易受攻击的系统可以在没有任何用户交互的情况下被利用。",
            MUI_R_Label: "成功利用此漏洞需要用户采取一些措施才能利用此漏洞。",
            MS_Heading: "成功的攻击是否会影响易受攻击组件以外的组件？ 如果是这样，则基础分数会增加，并且机密性、完整性和身份验证指标应相对于受影响的组件进行评分。",
            MS_X_Label: "使用分配给相应基本指标的值。",
            MS_U_Label: "被利用的漏洞只能影响由同一安全机构管理的资源。 在这种情况下，易受攻击的组件和受影响的组件要么相同，要么都由相同的安全机构管理。",
            MS_C_Label: "被利用的漏洞可能会影响超出易受攻击组件的安全权限管理的安全范围的资源。 在这种情况下，易受攻击的组件和受影响的组件是不同的，由不同的安全机构管理。",
            MC_Heading: "该指标衡量由于成功利用漏洞而对软件组件管理的信息资源的机密性的影响。 机密性是指将信息访问和披露仅限于授权用户，以及防止未经授权的用户访问或披露。",
            MC_X_Label: "使用分配给相应基本指标的值。",
            MC_N_Label: "受影响组件内的机密性不会丢失。",
            MC_L_Label: "有一些保密性的损失。 获得了对某些受限信息的访问权，但攻击者无法控制获得的信息，或者损失的数量或种类受到限制。 信息披露不会对受影响的组成部分造成直接的、严重的损失。",
            MC_H_Label: "机密性完全丧失，导致受影响组件中的所有资源都泄露给攻击者。 或者，仅获得了对一些受限信息的访问权，但所披露的信息会产生直接、严重的影响。",
            MI_Heading: "该指标衡量成功利用的漏洞对完整性的影响。 诚信是指信息的可信度和真实性。",
            MI_X_Label: "使用分配给相应基本指标的值。",
            MI_N_Label: "受影响的组件内没有完整性损失。",
            MI_L_Label: "可以修改数据，但攻击者无法控制修改的结果，或者修改的数量有限。 数据修改不会对受影响的组件产生直接、严重的影响。",
            MI_H_Label: "完全丧失完整性，或完全丧失保护。 例如，攻击者能够修改被受影响组件保护的任何/所有文件。 或者，只能修改部分文件，但恶意修改会对受影响的组件造成直接、严重的后果。",
            MA_Heading: "该指标衡量成功利用漏洞对受影响组件可用性的影响。 它指的是受影响的组件本身失去可用性，例如网络服务（例如，Web、数据库、电子邮件）。 由于可用性是指信息资源的可访问性，因此消耗网络带宽、处理器周期或磁盘空间的攻击都会影响受影响组件的可用性。",
            MA_X_Label: "使用分配给相应基本指标的值。",
            MA_N_Label: "受影响组件内的可用性没有影响。",
            MA_L_Label: "性能降低或资源可用性中断。 即使可以重复利用该漏洞，攻击者也没有能力完全拒绝为合法用户提供服务。 受影响组件中的资源要么始终部分可用，要么仅在某些时间完全可用，但总体而言，受影响组件没有直接、严重的后果。",
            MA_H_Label: "可用性完全丧失，导致攻击者能够完全拒绝访问受影响组件中的资源； 这种损失要么是持续的（攻击者继续进行攻击），要么是持久的（即使在攻击完成后情况仍然存在）。 或者，攻击者有能力拒绝某些可用性，但可用性的丧失会给受影响的组件带来直接、严重的后果（例如，攻击者不能中断现有连接，但可以阻止新连接；攻击者可以重复利用漏洞 即，在每次成功攻击的情况下，只会泄漏少量内存，但在反复利用后会导致服务完全不可用）。"
        }
    },
    registerFirstUser: '注册第一个用户',
    customData: '自定义数据',
    custom: '自定义',
    settings: '系统设置',
    profile: '个人信息',
    logout: '退出登录',
    login: '登录',
    username: '用户名',
    password: '密码',
    noLanguage: '没有定义语言，请在如下位置定义语言',
    noAudit: '没有定义审计类型，请在如下位置定义审计类型',
    auditTypes: '审计类型',
    searchFinds: '搜索查找',
    myAudits: '我的审计',
    usersConnected: '已在线连接用户',
    awaitingMyReview: '等待我审核',
    newAudit: '新的审计',
    search: '搜索',
    searchUsersPlaceholder: '按姓名、邮箱或用户名搜索用户...',
    any: '任意',
    all: '全部',
    status: '状态',
    actions: '操作',
    statusActive: '启用',
    statusDisabled: '禁用',
    enabled: '已启用',
    disabled: '已禁用',
    showing: '显示',
    to: '至',
    of: '共',
    user: '用户',
    users: '用户',
    userSelected: '个用户已选择',
    usersSelected: '个用户已选择',
    allRoles: '所有角色',
    twoFactorAuthentication: '2FA',
    forThisUser: '此用户',
    disableUsersWarning: '禁用的用户将无法登录或访问系统。你可以随时重新启用他们。',
    auditNum1: '个审计项目',
    auditNums: '个审计项目',
    resultsPerPage: '每页结果数量：',
    createAudit: '创建审计',
    name: '名称',
    shortName: '简称',
    selectAssessment: '选择评估类型',
    selectLanguage: '选择语言',
    participants: '审计员',
    language: '语言',
    company: '公司',
    companies: '公司',
    date: '日期',
    sections: '段落',
    generalInformation: '基本信息',
    networkScan: '网络扫描',
    findings: '问题发现',
    automaticSorting: '自动排序',
    sortBy: '排序按',
    sortOrder: '排序顺序',
    ascending: '升序',
    descending: '降序',
    newestFirst: '最新优先',
    oldestFirst: '最早优先',
    me: '我',
    cvssScore: 'CVSS分值',
    cvssTemporalScore: 'CVSS 时间分数',
    cvssEnvironmentalScore: 'CVSS 环境分数',
    priority: '优先级',
    remediation: '修复',
    remediationDifficulty: '修复难度',
    remediationComplexity: '修复复杂度',
    remediationPriority: '修复优先级',
    easy: '简单',
    medium: '中等',
    complex: '复杂',
    low: '低',
    high: '高',
    urgent: '紧急',
    title: '标题',
    category: '漏洞类别',
    selectCategory: '选择漏洞类别',
    noCategory: '无类别',
    vulnType: '漏洞类型',
    undefined: '未定义',
    vulnerabilityNum1: '个漏洞',
    vulnerabilitiesNums: '个漏洞',
    definition: '定义',
    proofs: '证明',
    details: '细节',
    completed: '已完成',
    type: '类型',
    lastModified: '最后修改',
    description: '说明',
    observation: '观测',
    references: '参考资料（每条1行）',
    customFields: '自定义字段',
    affectedAssets: '受影响资产',
    courseOfActions: '行动方案',
    template: '模板',
    client: '客户',
    reviewers: '审核人员',
    collaborator: '审计员',
    collaborators: '审计员',
    startDate: '开始日期',
    endDate: '结束日期',
    reportingDate: '报告日期',
    auditScope: '范围（每个一行）',
    import: '导入',
    export: '导出',
    hostsAssociateScopes: '将导入的主机与范围关联',
    handleCustomData: '处理自定义数据',
    clients: '客户',
    templates: '模板',
    addClient: '添加客户',
    editClient: '编辑客户',
    firstname: '名',
    lastname: '姓',
    email: '邮箱',
    function: '职能',
    phone: '座机',
    cell: '手机',
    jobTitle: '职位',
    role: '角色',
    collatorator: '审计员',
    addCollaborator: '添加审计员',
    editCollaborator: '编辑审计员',
    addCompany: '添加公司',
    editCompany: '编辑公司',
    logo: '图标',
    quantifier: '个',
    languages: '语言',
    extension: '扩展名',
    createTemplate: '创建模板',
    file: '文件',
    editTemplate: '编辑模板',
    importVulnerabilities: '导入漏洞',
    importVulnerabilitiesInfo: `从一个.yml或.json文件导入漏洞。（支持 Serpico 格式）<br />
    本操作可使您轻松导入一批漏洞模板。`,
    importVulnerabilitiesOk: '全部 <strong>{0}</strong> 个漏洞创建成功',
    importVulnerabilitiesAllExists: '全部 <strong>{0}</strong> 个漏洞标题已存在',
    importVulnerabilitiesPartial: '<strong>{0}</strong> 个漏洞创建成功<br /><strong>{1}</strong> 个漏洞标题已存在',
    exportVulnerabilities: '导出漏洞',
    exportVulnerabilitiesInfo: `将漏洞导出为 yaml 格式。之后可以轻松地重新导入此导出。`,
    deleteAllVulnerabilities: '删除所有漏洞',
    deleteAllVulnerabilitiesInfo: `删除库中所有漏洞。<br />
    <strong>本操作不可逆！！</strong>`,
    customSections: '自定义段落',
    listOfLanguages: '语言列表',
    editLanguages: '编辑语言',
    locale: '语言环境',
    auditTypesUsedInAudits: '审计中用到的审计类型',
    languageUsedInAuditsAndVuls: '在审计和漏洞中使用的语言',
    addSections: '添加段落',
    hideBuiltInSections: '隐藏内置段落',
    listOfAuditTypes: '审计类型列表',
    editAuditTypes: '编辑审计类型',
    createAtLeastOneLanguage: '请至少创建一种语言',
    createVulnerabilityTypes: '创建漏洞类型以便在漏洞管理和问题发现中使用',
    vulnerabilityTypesList: '漏洞类型列表',
    editVulnerabilityTypes: '编写漏洞类型',
    createVulnerabilityCategories: '创建漏洞类别以便在漏洞管理和漏洞发现中使用',
    defaultSortingOptions: '默认排序选项',
    listOfCategories: '漏洞类别列表',
    editCategories: '编辑漏洞类别',
    createAndManageCustomFields: '为不同视图创建和管理自定义表单',
    selectView: '选择视图',
    selectSection: '选择段落',
    selectComponent: '选择组件',
    label: '标签',
    size: '字体',
    offset: '偏移',
    required: '必填项',
    optionsLanguage: '选择语言',
    addOption: '添加选项',
    languageForDefaultText: '语言（用于默认文本）',
    createCustomSections: '创建自定义段落以便在审计中使用',
    fieldForTemplate: '字段（用于模板）',
    customIcon: '图标（Material/Font Awesome）',
    field: '字段',
    editSections: '编辑段落',
    vulnerabilityTypes: '漏洞类型',
    vulnerabilityCategories: '漏洞类别',
    auditGeneral: '审计编辑 -  常规',
    auditFinding: '审计编辑 -  问题发现',
    auditSection: '审计编辑 -  段落',
    vulnerability: '漏洞编辑',
    checkbox: '复选框',
    editor: '编辑器',
    input: '输入框',
    radio: '单选框',
    select: '下拉列表（单选）',
    selectMultiple: '下拉列表（多选）',
    space: '空格填充',
    updateUserInformation: '更新用户信息',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    currentPassword: '当前密码 *',
    reports: '报告',
    reportsImagesBorder: '报告图片边框',
    addBorderToImages: '在生成的报告中，给图片添加边框。',
    currentColor: '当前颜色：',
    cvssColors: 'CVSS 颜色',
    changeCvssColorsDescription: '在生成的报告中，给不同CVSS严重性设置不同的颜色。',
    critical: '紧急',
    informational: '信息性',
    reviews: '审核',
    auditUpdateAfterApproval: '在审核通过后更新审计项目',
    changeApproveBehaviorIfAuditUpdated: '当审计项目更新后，修改审核通过状态时将执行：',
    removeAllPriorApprovals: '移除所有该项目之前的批准',
    keepAllPriorApprovals: '保留所有该项目之前的批准',
    mandatoryReview: '强制性审核',
    mandatoryReviewInfo: `使审查过程成为强制性的。 <br />激活后，用户无法导出审核，除非已获得指定数量的审核者批准。
    <br/>最少数量的审阅者还用于确定报告是否标记为已批准。`,
    minimalNumberOfReviewers: '审核者的最少数量',
    saveSettings: '保存系统设置',
    revertSettingsToDefaults: '还原默认系统设置',
    importSettings: '导入系统设置',
    exportSettings: '导出系统设置',
    mergeVulnerabilities: '合并漏洞',
    mergeVulnerabilitiesInfo: `本操作的目标是将不同语言的不同漏洞合并到同一个漏洞中。<br /> 
    所以必须至少存在 2 种语言。`,
    newVulnerability: '新漏洞',
    createNewVulnerability: '创建新漏洞',
    filters: '筛选',
    views: '视图',
    or: '或',
    reset: '重置',
    createdBy: '创建者',
    filtersApplied: '个筛选条件已应用',
    unsavedChangesOnly: '仅显示未保存的更改',
    noMatchingRecords: '未找到匹配的记录',
    selectVulnerability: '选择一个漏洞进行查看或编辑',
    selectVulnerabilityHint: '从左侧列表中选择一个漏洞，查看其详细信息、CVSS 评分、参考资料等。',
    total: '总共',
    addVulnerability: '添加漏洞',
    editVulnerability: '编辑漏洞',
    changeCategory: '修改类别',
    listOfSections: '段落列表',
    updateVulnerability: '更新漏洞',
    current: '当前的',
    proposalsCount: '{count} 条提案',
    reviewVulnerabilityProposals: '审阅漏洞提案',
    currentVersion: '当前版本',
    proposedVersion: '提议版本',
    today: '今天',
    yesterday: '昨天',
    languageAddFromRight: '语言（从右侧添加）',
    languageMoveToLeft: '语言（移动到左侧）',
    merge: '合并',
    goBack: '返回',
    twoStepVerification: '两步验证2-Step Verification',
    twoStepVerificationMessage: '打开您的身份验证应用程序并输入它提供的安全码。',
    captions: '标题',
    captionsDescription: '添加将在报告中使用的标题标签（默认为 \'Figure\'）',
    spellcheck: '拼写检查',
    enableSpellcheck: '启用拼写检查',
    spellcheckCategories: '类别',
    spellcheckCategory: {
        CASING: { label: '大小写', description: '大小写错误，如 "english" 应为 "English"' },
        COMPOUNDING: { label: '复合词', description: '复合词错误，如缺少连字符' },
        GRAMMAR: { label: '语法', description: '语法错误，如动词形式或主谓一致错误' },
        TYPOS: { label: '拼写错误', description: '拼写错误和常见的打字错误' },
        PUNCTUATION: { label: '标点符号', description: '缺失或错误的标点符号' },
        TYPOGRAPHY: { label: '排版', description: '排版问题，如错误的引号或破折号' },
        CONFUSED_WORDS: { label: '易混淆词', description: '常见易混淆词，如 "their" 和 "there"' },
        REPETITIONS: { label: '重复', description: '无意重复的词语或短语' },
        REDUNDANCY: { label: '冗余', description: '无意义的冗余词' },
        STYLE: { label: '风格', description: '提高写作清晰度或简洁性的风格建议' },
        SEMANTICS: { label: '语义', description: '含义使用不当的词语' },
        COLLOQUIALISMS: { label: '口语表达', description: '非正式或口语化表达' },
        MISC: { label: '其他', description: '上述类别未涵盖的其他规则' },
    },
    draftRecovery: {
        title: '已恢复的更改',
        message: '查看您已恢复的更改与最后保存版本之间的差异。',
        savedAt: '本地保存于',
        currentVersion: '最后保存的版本',
        draftVersion: '您已恢复的更改',
        noDifferences: '未发现差异',
        unifiedView: '统一视图',
        splitView: '分屏视图',
        localDraftLabel: '已恢复的更改',
        serverVersionLabel: '服务器版本',
        localDraftExists: '存在已恢复的更改',
        viewingLocalDraft: '您正在查看已恢复的更改',
        notSavedToServer: '保存以保留您的更改',
        viewingServerVersion: '您正在查看最后保存的版本',
        localDraftNotApplied: '存在已恢复的更改但未应用',
        draftExpiresIn: '将在以下时间后过期：',
        draftExpired: '已过期',
        clearedAfterInactivity: '在此之前可恢复',
        discardDraft: '恢复到已保存版本',
        discardLocalChanges: '返回到最后保存的版本',
        viewChangesLabel: '查看更改',
        reviewChangesInDraft: '查看此草稿中的更改',
        restoreDraftLabel: '应用已恢复的更改',
        replaceWithDraft: '用已恢复的更改替换当前内容',
        deletePermanently: '永久删除已恢复的更改',
        actionCannotBeUndone: '此操作无法撤销',
        compareWithDraft: '将已保存版本与已恢复的更改对比',
        saveHint: '使用工具栏中的保存（Ctrl+S）来保存您的更改。',
        edited: '已编辑',
        editedJustNow: '刚刚编辑'
    },
    roles: 'Roles',
    rolesPageSubtitle: '管理角色及其权限。角色定义用户可以访问和执行的操作。',
    createRole: 'Create Role',
    editRole: 'Edit Role',
    viewRole: 'View Role',
    deleteRole: 'Delete Role',
    searchRolesPlaceholder: '搜索角色...',
    allTypes: '所有类型',
    customRole: '自定义',
    adminRoleDescription: '完整平台访问权限。管理所有设置、用户和数据。',
    userRoleDescription: '查看已分配数据的基础访问权限。',
    roleDescriptionFallback: '未提供描述。',
    allPermissions: '所有权限',
    roleDisplayName: 'Display Name',
    roleName: 'Role Name',
    roleNameImmutableHint: 'Cannot be changed after creation',
    permissions: 'Permissions',
    coreAccess: 'Core Access',
    featurePermissions: 'Feature Permissions',
    cloneFrom: 'Clone From',
    searchPermissions: 'Search permissions...',
    selected: 'selected',
    assigned: 'assigned',
    expandAll: 'Expand all',
    collapseAll: 'Collapse all',
    clearAll: 'Clear all',
    noPermissionsFound: 'No permissions found',
    systemRole: 'System',
    cannotEditSystemRole: 'System roles cannot be edited',
    usersWithRole: 'Users with this role',
    roleType: 'Type',
    addRoles: 'Add Roles',
    removeRoles: 'Remove Roles',
    bulkActionsSelected: 'Bulk actions selected',
    auditQa: {
        infos: 'Infos',
        title: 'QA 审查',
        loading: '正在加载 QA 结果…',
        running: '正在运行 QA 检查...',
        runInProgress: 'QA 进行中… 开始于 {time}',
        runInProgressNoTime: 'QA 进行中…',
        runInProgressProgrammatic: '内置检查进行中… 开始于 {time}',
        runInProgressProgrammaticNoTime: '内置检查进行中…',
        runInProgressAi: 'AI 检查进行中… 开始于 {time}',
        runInProgressAiNoTime: 'AI 检查进行中…',
        failed: '无法运行报告 QA 审查',
        previousProgrammaticRun: '显示内置检查的数据',
        previousProgrammaticRunAt: '显示内置检查的数据（{date}）',
        previousAiRun: '显示 AI 检查的数据',
        previousAiRunAt: '显示 AI 检查的数据（{date}）',
        runSourceProgrammatic: '内置检查',
        runSourceAi: 'AI 检查',
        lastRun: '上次运行',
        noResultsYet: '暂无 QA 结果。请在上方选择运行方式。',
        outdatedBanner: '这些结果已过期——自上次运行以来内容已更改。建议重新运行。',
        runProgrammatic: '运行内置检查',
        runAi: '运行 AI 检查',
        runAll: '运行内置 + AI 检查',
        runAgain: '重新运行',
        runAgainScoped: '重新运行 {scope}',
        scopeProgrammatic: '内置检查',
        scopeAi: 'AI 检查',
        scopeAll: '内置 + AI 检查',
        errors: '错误',
        warnings: '警告',
        total: '总计',
        filterAll: '全部',
        noIssues: '未标记任何问题',
        goToFinding: '跳转到问题发现',
        goToSection: '跳转到段落',
        aiReview: 'AI 审查——请在采取行动前核实',
        showMore: '显示另外 {count} 项',
        category: {
            completeness: '完整性',
            redaction: '编写规范',
            customer: '客户',
            instructions: 'QA 说明',
            references: '参考资料',
            imageCaptions: '图片标题',
            duplicates: '重复项',
            aiDuplicates: 'AI 重复项',
            aiUnlinkedTranslations: '未关联的翻译',
            other: '其他'
        },
        location: {
            general: '基本信息',
            network: '网络',
            report: '报告',
            untitledFinding: '未命名问题发现'
        }
    },
    vulnerabilityQa: {
        titleSingle: 'QA 审查',
        titleAll: '漏洞库 QA 审查',
        untitled: '未命名漏洞',
        loading: '正在加载 QA 结果…',
        running: '正在审查漏洞的完整性、重复条目、参考链接及内容规范...',
        failed: '无法运行漏洞 QA 审查',
        recheckFailed: '无法重新检查该漏洞',
        showReview: '显示 QA 审查',
        hideReview: '隐藏 QA 审查',
        reviewedCount: '已针对所选语言审查 {count} 个漏洞。',
        runAllPreview: '使用完整性、重复项和 AI 检查审查 {language} 中的全部 {count} 个漏洞。在后台运行——您可以继续工作。',
        progressTemplates: '已检查 {total} 个漏洞中的 {processed} 个…',
        progressCatalog: '跨漏洞检查：{total} 项中的 {done} 项…',
        reusedCached: '复用了 {count} 个未更改的结果',
        partialReport: '已检查 {total} 个漏洞中的 {checked} 个——请重新运行 QA 以审查其余漏洞。',
        cancel: '取消',
        recheckHint: '仅重新检查此漏洞。不包括跨漏洞检查（重复项、翻译）——请使用“重新运行”来执行这些检查。',
        recheckUpToDate: '已是最新——自上次 QA 运行以来无更改',
        runAgainHint: '仅重新检查已过期的漏洞',
        rowOutdated: '已过期',
        catalogGroup: '跨漏洞检查',
        goToVulnerability: '跳转到漏洞',
        resolve: '解决此漏洞',
        resolveIssue: '解决此问题',
        unresolve: '标记为未解决',
        resolvedLabel: '已解决',
        filterActive: '活动',
        filterOutdated: '已过期',
        filterResolved: '已解决',
        filterAllStatus: '全部',
        filterRows: '按漏洞标题筛选...',
        resolveFailed: '无法更新解决状态',
        clearFilters: '清除筛选',
        notFoundInList: '该漏洞已不在库中——请重新运行 QA 以刷新报告。',
        notVisibleWithFilters: '该漏洞已被当前筛选条件隐藏。',
        location: {
            database: '漏洞库',
            global: '全局'
        }
    },
    aiIntegration: {
        pageTitleWriting: 'Assisted Writing',
        pageTitleQa: 'Quality Assurance',
        disabledBanner: 'AI integration is disabled in organization settings. Enable it from Settings to manage assisted writing and quality assurance.',
        noPermissionBanner: 'You do not have permission to view {page} settings.',
        loadFailed: 'Failed to load AI integration settings',
        tabPrompts: 'Prompts',
        tabGuidelines: 'Writing Guidelines',
        tabProgrammaticChecks: 'Built-in Checks',
        tabAiChecks: 'AI Checks',
        prompts: {
            description: "Configure generic prompts for the AI chat and field-specific generation prompts. Provider and model settings are managed in Settings.",
            readOnly: 'Read-only: you do not have permission to update prompts.',
            genericPrompts: 'Generic Prompts',
            categoriesAndFields: 'Prompts & Fields',
            nodeFindings: 'Findings',
            nodeBuiltinFields: 'Built-in fields',
            nodeAllCategories: 'All categories',
            nodeVulnerabilities: 'Vulnerabilities',
            nodeSections: 'Sections',
            nodeAllSections: 'All sections',
            searchAllPlaceholder: 'Search',
            filterPlaceholder: 'Search by field name',
            globalCaption: 'Reusable prompts listed in the AI chat in this order (spellcheck, translation, style rewrites, etc.). Drag to reorder.',
            noGlobalPrompts: 'No generic prompts yet. Add one to expose document-wide actions in the AI chat.',
            noFieldsMatch: 'No fields match your search.',
            addGlobalPrompt: 'Add prompt',
            deleteSelected: 'Delete selected ({count})',
            deletePrompt: 'Delete prompt',
            deleteConfirmTitle: 'Delete generic prompt(s)',
            deleteConfirmMessage: 'Delete {count} generic prompt(s)? This cannot be undone.',
            deleteSuccess: '{count} generic prompt(s) deleted',
            columnField: 'Field',
            columnPrompt: 'Prompt',
            aiAssist: 'AI Assist',
            label: 'Label',
            labelHint: 'Shown in the AI chat (e.g. Spellcheck my document)',
            enabled: 'Enabled',
            disabled: '已禁用',
            prompt: 'Prompt',
            newPrompt: 'New prompt',
            saveChanges: 'Save changes',
            resetToDefault: 'Reset to default',
            resetConfirmTitle: 'Reset prompt',
            resetConfirmMessage: 'Reset the "{field}" prompt to its default text?',
            resetSuccess: 'Prompt reset to default',
            discardChangesTitle: 'Unsaved changes',
            discardChangesMessage: 'You have unsaved changes to this prompt. Discard them and continue?',
            variablesTitle: 'Available variables',
            saveSuccess: 'Assisted writing prompts updated successfully',
            saveFailed: 'Failed to update assisted writing prompts',
            unsavedChanges: '{count} unsaved change(s)',
            outputTypeHtml: 'HTML',
            outputTypeList: 'List',
            outputTypeText: 'Text'
        },
        guidelines: {
            description: 'Organization-wide writing rules provided to every AI request as additional context. Use plain text or Markdown, similar to a project style guide.',
            readOnly: 'Read-only: you do not have permission to update writing guidelines.',
            label: 'Writing guidelines',
            hint: 'Examples: tone, terminology, data redaction rules, forbidden disclosures, report structure conventions.',
            save: 'Save guidelines',
            saveSuccess: 'Writing guidelines updated successfully',
            saveFailed: 'Failed to update writing guidelines'
        },
        qa: {
            description: 'Configure which automated checks run when reviewing audit reports and vulnerability templates.',
            readOnly: 'Read-only: you do not have permission to update QA settings.',
            aiChecksDisabledChip: '已禁用',
            aiChecksDisabledBefore: 'AI 集成已禁用。请在',
            aiChecksDisabledLink: '设置',
            aiChecksDisabledAfter: '中启用以运行 AI 检查。',
            instructionsTitle: 'QA instructions',
            instructionsDescription: 'Organization-wide QA checklist provided to the AI reviewer. Use plain text or Markdown to define additional required sections, fields, and report rules beyond the minimum completeness check.',
            instructionsLabel: 'QA instructions',
            instructionsHint: 'Examples: require executive summary and scope sections, mandate remediation text, verify customer naming, retest wording.',
            save: 'Save QA settings',
            saveInstructions: 'Save instructions',
            saveSuccess: 'QA settings updated successfully',
            saveFailed: 'Failed to update QA settings',
            saved: 'Saved',
            checkCompletenessLabel: 'Report completeness',
            checkCompletenessDescription: 'Minimum report requirements only: audit name, at least one finding, and finding titles. Findings still in redaction are flagged as warnings.',
            checkReferencesLabel: 'Reference links',
            checkReferencesDescription: 'Validate that HTTP(S) URLs listed in finding references are reachable.',
            checkImageCaptionsLabel: 'Image captions',
            checkImageCaptionsDescription: 'Flag images and figure captions that still use the imported filename (for example screenshot.png).',
            checkDuplicatesLabel: 'Duplicate templates',
            checkDuplicatesDescription: 'Fast structural checks for templates in the same language with the same title or identical description, observation, and remediation content.',
            checkAiDuplicatesLabel: 'AI duplicate templates',
            checkAiDuplicatesDescription: 'AI review to identify templates that describe the same underlying vulnerability even when titles differ or content is paraphrased.',
            checkAiUnlinkedTranslationsLabel: 'AI unlinked translations',
            checkAiUnlinkedTranslationsDescription: 'AI review to identify the same vulnerability template stored in separate records for different languages instead of being merged into one multilingual record.',
            checkRedactionLabel: 'Writing guidelines review',
            checkRedactionDescription: 'AI review of report content against organization writing guidelines.',
            checkCustomerLabel: 'Customer alignment',
            checkCustomerDescription: 'AI review that the report content matches the expected customer and company.',
            checkInstructionsLabel: 'QA instructions',
            checkInstructionsDescription: 'AI review against organization QA instructions below, including any additional required sections or fields you define.',
            usesTokens: 'Uses tokens',
            scopeAudit: 'Audit reports',
            scopeVulnerability: 'Vulnerability database'
        },
        settingsCard: {
            title: 'AI Integration',
            disableHint: 'Disable to fully hide AI prompt configuration and AI generation buttons for all users.',
            providerTitle: 'AI Provider'
        },
        menu: {
            assistedWriting: 'Assisted Writing',
            qualityAssurance: 'Quality Assurance'
        },
        provider: {
            defaultBadge: 'Default',
            setDefaultLabel: 'Set as default provider',
            setDefaultHint: 'Used when a request does not specify a provider. Always available to users.',
            configuredHint: 'This provider is configured',
            allowUsersLabel: 'Allow users to select this provider',
            allowUsersHint: 'When enabled, users can pick this provider for AI generation and QA. The default provider is always available.',
            openaiBaseUrl: 'OpenAI Base URL',
            openaiModel: 'OpenAI Model',
            openaiApiKey: 'OpenAI API Key',
            anthropicBaseUrl: 'Anthropic Base URL',
            anthropicModel: 'Anthropic Model',
            anthropicVersion: 'Anthropic Version',
            anthropicApiKey: 'Anthropic API Key',
            deepseekBaseUrl: 'DeepSeek Base URL',
            deepseekModel: 'DeepSeek Model',
            deepseekApiKey: 'DeepSeek API Key',
            ollamaBaseUrl: 'Ollama Base URL',
            ollamaModel: 'Ollama Model',
            ollamaApiKey: 'Ollama API Key',
            awsRegion: 'AWS Region',
            bedrockModelId: 'Bedrock Model ID',
            bedrockCredentialsHint: 'Configure either a Bedrock API key or IAM credentials.',
            bedrockApiKey: 'Bedrock API Key',
            awsAccessKeyId: 'AWS Access Key ID',
            awsSecretAccessKey: 'AWS Secret Access Key',
            awsSessionToken: 'AWS Session Token (optional)',
            testConnection: 'Test connection',
            testSuccess: 'Connection successful',
            testSuccessWithModel: 'Connection successful (model: {model})',
            testFailed: 'Connection failed'
        }
    },
    aiChat: {
        providerLabel: 'Provider',
        selectedText: '已选文本',
        startPrompt: '描述你希望如何修改所选文本。',
        reviewDefaultPrompt: '选择提示词或提出任何问题。',
        defaultPromptPlaceholder: '提出任何问题',
        askAnything: '提出任何问题',
        defaultPromptOption: '字段默认值',
        promptSelectLabel: '提示词模板',
        howCanIHelp: '我能帮您什么？',
        quickPrompts: '快捷提示词',
        quickPromptsHint: '使用字段默认提示词，或选择可复用的提示词。',
        searchPrompts: '搜索提示词...',
        searchResults: '搜索结果',
        fieldPrompt: '字段提示词',
        defaultPromptHint: '使用为此字段配置的预定义指令。',
        usePrompt: '使用',
        recentPrompts: '最近使用',
        allPrompts: '所有提示词',
        browsePrompts: '浏览提示词',
        noPromptsFound: '没有符合搜索条件的提示词。',
        applyField: '应用到字段',
        previewChanges: '预览更改',
        originalResponse: '原始回复',
        inputPlaceholder: '让 AI 重写所选内容...',
        sendHint: '提示：按 Ctrl+Enter 发送。',
        send: '发送',
        stop: '停止生成',
        apply: '应用到所选内容',
        you: '你',
        assistant: '助手',
        updatedDraft: '这是所选文本的更新版本。',
        emptyDraft: 'AI 回复为空',
        requestFailed: '无法生成 AI 回复',
        timedOut: '请求超时。复杂查询可能会出现这种情况——您的提示已保留，请重试。',
        noSelection: '使用 AI 前请先在字段中选择文本。',
        generating: '正在生成内容...',
        leaveWhileGeneratingTitle: 'AI 正在生成',
        leaveWhileGeneratingMessage: '内容仍在生成中。现在离开将取消当前 AI 请求。',
        closeWhileGeneratingMessage: '内容仍在生成中。仍要关闭 AI 面板吗？',
        discardAiSessionTitle: '放弃 AI 会话？',
        discardAiSessionMessage: '该字段将被解锁，当前 AI 对话将丢失。',
        discardAndStart: '放弃并重新开始',
        leaveWhileAiSessionMessage: '此字段已被活动的 AI 会话锁定。现在离开将放弃该会话。',
        activeSession: '请先完成或关闭当前 AI 会话，然后再开始新的会话。',
        applySelection: '应用所选内容',
        insertAtCursor: '插入到光标处',
        anchorCollapsed: '所选文本已被删除。草稿将插入到其原始位置。',
        anchorLost: '无法追踪原始选区。请重新选择文本后重试，或手动复制回复内容。',
        tooltip: 'AI 助手'
    },
}
